import { configureStore } from '@reduxjs/toolkit'
import heartReducer from './heartSlice';
import groupReducer from './groupSlice';
import doneReducer from './doneSlice';
import userReducer from './userSlice';
import mqttReducer from './mqttSlice';

export const store = configureStore({
  reducer: {
    heart: heartReducer,
    group: groupReducer,
    done: doneReducer,
    user: userReducer,
    mqtt: mqttReducer,
  },
})